// extracted by mini-css-extract-plugin
export default {"header":"Header_header__a-kuR","placesauto":"Header_placesauto__pcr94","search":"Header_search__fstaC"};